import React, { useMemo } from 'react'
import { Stack } from '../../../components/DesignSystem'
import Formatter from '../../../helpers/Formatter'
import { RadioGroup } from '../../../components/DesignSystem/RadioGroup'
import { Control } from 'react-hook-form'

const SELECT_DENOMINATION_AMOUNT_TEXT = 'Select an amount to purchase'

interface GiftCardSelectorProps {
	denominations: number[]
	deviceHasInternet: boolean
	control: Control<any>
	name: string
}

export default function GiftCardSelector({
	denominations,
	deviceHasInternet,
	control,
	name,
}: GiftCardSelectorProps) {
	const options = useMemo(
		() =>
			denominations.map(denomination => ({
				value: denomination.toString(),
				label: Formatter.formatCurrency(denomination / 100, 'CAD', 0),
				disabled: !deviceHasInternet,
			})),
		[denominations, deviceHasInternet]
	)

	return (
		<Stack gap="sm" align={{ mobile: 'left', tablet: 'left', desktop: 'left' }}>
			<RadioGroup
				label={SELECT_DENOMINATION_AMOUNT_TEXT}
				options={options}
				control={control}
				name={name}
				direction="horizontal"
				align={{ mobile: 'start', tablet: 'start', desktop: 'start' }}
			/>
		</Stack>
	)
}
